import { addNewCourseForStudent } from '../../../../services/api-requests/api-request'
import { Button, CircularProgress } from '@mui/material'

import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useSnackbarComponent } from '../../../SnackbarComponents/useSnackbarComponent'
import { ISchool } from '../../../../interfaces/school.interface'
import { ICourse } from '../../../../interfaces/ICourse'

interface IRegisterToCourseButtonProps {
  course: ICourse
  school: ISchool
  buttonSize?: 'small' | 'large' | 'medium'
  buttonStyle?: React.CSSProperties
  buttonText?: React.ReactNode
  onRegisterSuccessful: () => void
}

export default function RegisterToCourseButton(
  props: IRegisterToCourseButtonProps,
) {
  const [courseRegisterLoading, setCourseRegisterLoading] = React.useState(
    false,
  )
  const snackbarHook = useSnackbarComponent()

  async function addCourse() {
    const course = props.course
    const courseId = course._id
    const courseCode = course.course_code

    if (!course) {
      console.log('selected course is not defined', course)
      return
    }

    try {
      setCourseRegisterLoading(true)
      const axiosRes = await addNewCourseForStudent(courseId, courseCode)
      console.log(axiosRes)
      setCourseRegisterLoading(false)
      snackbarHook.open('Registration successful', 'success')
      props.onRegisterSuccessful()
    } catch (err) {
      console.log(err)
      alert('Error registering for class')
      setCourseRegisterLoading(false)
    }
  }

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        fullWidth={true}
        disableElevation={true}
        size={props.buttonSize || 'large'}
        style={
          props.buttonStyle || {
            height: '50px',
            // maxWidth: "350px"
          }
        }
        disabled={courseRegisterLoading || props.course?.isComingSoon}
        onClick={addCourse}
      >
        {props.buttonText || (
          <>
            Open class <ArrowForwardIcon style={{ marginRight: '5px' }} />
          </>
        )}
      </Button>
      {courseRegisterLoading && <CircularProgress size={15} />}
    </>
  )
}
